import Vue from 'vue';
import _ from 'lodash';
import auth from './auth';

const state = {
  currentAccount: null,
  currentAccountId: null,
  roomId: null,
};

const actions = {
  FETCH_ACCOUNT: async ({ commit }, { kuzzle, index }) => {
    if (!index) {
      return;
    }
    const searchOptions = {
      scroll: '1m',
    };

    let searchedAccount = await kuzzle.query({
      controller: 'document',
      action: 'search',
      index: index,
      collection: 'accounts',
      scroll: '1m',
      loggedAsUser:
        auth.state.currentUser && auth.state.currentUser.loggedAsUser,
    });
    console.log('searchedAccount', searchedAccount.result.hits.length);
    commit('RESET_ACCOUNT');
    searchedAccount.result.hits.forEach((a) => {
      commit('SET_CURRENT_ACCOUNT', a);
    });
  },
  SUBSCRIBE: async ({ commit }, { kuzzle, index }) => {
    const roomId = await kuzzle.realtime.subscribe(
      index,
      'accounts',
      {
        loggedAsUser:
          auth.state.currentUser && auth.state.currentUser.loggedAsUser,
      },
      (notification) => {
        switch (notification.action) {
          case 'create':
            commit('SET_CURRENT_ACCOUNT', notification.result.hits[0]._source);
            break;
          case 'update':
            commit('UPDATE_ACCOUNT', notification.result._source);
            break;
          //case 'delete':
          //  commit('DELETE_MISSION', notification.result._id);
          //  break;
          //case 'create':
          //  commit('ADD_MISSION', notification.result);
          //  break;
        }
      },
      { scope: 'all' }
    );
    commit('SET_ROOM_ID', roomId);
  },
  UNSUBSCRIBE: async ({ commit, state }, kuzzle) => {
    if (state.roomId) {
      await kuzzle.realtime.unsubscribe(state.roomId);
    }
    commit('SET_ROOM_ID', null);
  },
  UPDATE_ACCOUNT: async ({}, { accountId, accountPayload, kuzzle, index }) => {
    console.log('action update account', accountPayload);
    await kuzzle.document.update(index, 'accounts', accountId, accountPayload);
  },
};

const mutations = {
  SET_CURRENT_ACCOUNT: (state, account) => {
    state.currentAccount = account._source;
    state.currentAccountId = account._id;
  },
  UNSET_CURRENT_ACCOUNT: (state) => {
    state.currentAccount = null;
  },
  RESET_ACCOUNT: (state) => {
    state.currentAccount = null;
    state.currentAccountId = null;
  },
  UPDATE_ACCOUNT: (state, accountPayload) => {
    state.currentAccount = accountPayload;
  },

  SET_ROOM_ID: (state, roomId) => {
    state.roomId = roomId;
  },
};

const getters = {
  currentAccount: (state) => state.currentAccount,
  currentAccountId: (state) => state.currentAccountId,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
